$(() => {
  $('.nav-pills__selector a').click(function (event) {
    event.preventDefault();

    $(this).tab('show');
  });
});
